<div id="{id}" class="terms-and-conditions-section" [ngClass]="{'terms-and-conditions-modal': !showHyperLink}">
    <div *ngIf="showHyperLink" class="tc-widget">
        <div class="tc-widget-title">
            <h3 class="tc-widget-title-text">{{widgetTitle}}</h3>
            <span *ngIf="ssdCreateNewEditView"
            class="drag-delete"
            (click)="removeTileItem()"
            placement="bottom"
            [ngbTooltip]="deleteIconNotification"
            container="body"
          ></span>
          <ng-template #deleteIconNotification>
            <p class="tooltip-content">{{ "COMMON.DELETE_WIDGET" | translate }}</p>
          </ng-template>
        </div>
        <div tile-content class="tc-widget-content">
            {{'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS_LABEL' | translate}}
            <a class="tc-action-text" (click)="showTermsAndConditions()">{{'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS' |
                translate}}</a>
        </div>
    </div>
    <div *ngIf="!showHyperLink" [ngTemplateOutlet]="termsAndConditionsModal">
    </div>
    <ng-template #termsAndConditionsModal class="tc-modal-container" style="display: none;">
        <div id="tcModalId" class="tc-modal-dialog">
            <div class="d-flex tc-modal-header">
                <div class="col-11">
                    <div class="row">
                        <div class="col-xl-10 col-lg-9 col-md-8 col-sm-8 col-9 tc-modal-header-text">
                            {{'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS' | translate}}</div>
                        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-4">
                            <nalco-button-dropdown [isDisabled]="true" [ddData]="LanguageListDropdown"
                                (ddChange)="systemSelected($event)" [showSelect]="true"
                                [showLabelWithSelection]="false"></nalco-button-dropdown>
                        </div>
                    </div>

                </div>
                <div class="col-1 pr-0 m-auto">
                    <button type="button" aria-label="Close" class="close"><img
                            src="../../../../assets/images/modal-blueclose-icon.svg" alt="close" class="close_img"
                            (click)="closeTermsAndConditions('close')">
                    </button>
                </div>
            </div>
            <div class="tc-modal-content">
                <div *ngIf="errorMsgType === 0; else errorMsgBlock" class="tc-content-section">
                    <div id="tc_scroll" class="tc-data">
                        <div [innerHtml]="sanitizedHtml"></div>
                    </div>
                    <div class="d-flex">
                        <label *ngIf="sanitizedHtml" class="form-check-label checkbox-items d-block mb-3">
                            <input [disabled]="isCheckboxDisabled" type='checkbox' [checked]="isTCAccepted"
                                (change)="isTCAccepted = !isTCAccepted">
                            <span class="float-end legend-text"></span>
                            <span class="checkmark" [ngClass]="{'disabled': isCheckboxDisabled}"></span>
                            <p class="accept-tc-text m-auto">
                                <b>{{'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS_CONSENT' | translate}}</b>
                            </p>
                        </label>
                    </div>
                    <span *ngIf="showLoader" class="loader" [ngClass]="{'hyperlink-loader': showHyperLink}"></span>
                </div>
            </div>
            <div class="tc-modal-footer">
                <div class="tc-modal-footer-content">
                    <button type="button" class="btn btn-secondary" (click)="closeTermsAndConditions('close')">
                        {{'COMMON.CANCEL' | translate}}
                    </button>
                    <button [disabled]="!isTCAccepted || errorMsgType !== 0" type="button" class="btn btn-primary"
                        (click)="onAcceptTermsAndConditions()">
                        {{'COMMON.CONTINUE' | translate }}
                    </button>
                </div>
            </div>
        </div>

    </ng-template>

    <ng-template #errorMsgBlock>
        <span *ngIf="errorMsgType === 1">
            <span [translate]="'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS_FETCH_ERROR_MESSAGE'"
                [translateParams]="{ supportEmail: supportEmailId }"></span>
        </span>
        <span *ngIf="errorMsgType === 2">
            <span [translate]="'TERMS_AND_CONDITIONS.TERMS_AND_CONDITIONS_SAVE_ERROR_MESSAGE'"
                [translateParams]="{ supportEmail: supportEmailId }"></span>
        </span>
    </ng-template>
</div>